import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'

import { slugify } from '../utils/helpers'

export const PublicationSidebar = ({
  tags = [],
  categories = [],
  thumbnail,
}) => {
  const cates = categories?.filter(function (category) {return category !== 'Highlight'})

  return (
    <aside className="post-sidebar">
      {thumbnail && (
        <div className="post-image">
          <Img fluid={thumbnail.childImageSharp?.fluid} />
        </div>
      )}

      <div className="post-sidebar-card">
        {cates && (
          <div>
            <h2>Categories</h2>
            <ul>
              {cates.map((cat) => {
                return (
                  <li>
                  <Link
                    key={cat}
                    to={`/categories/${slugify(cat)}`}
                  >
                    {cat}
                  </Link>
                  </li>
                )
               })}
            </ul>
          </div>
        )}

        <h2>Tags</h2>
        <div className="tags">
          {tags.map((tag) => {
            return (
              <Link
                key={tag}
                to={`/tags/${slugify(tag)}`}
                className="tag"
                activeClassName="active"
              >
                {tag}
              </Link>
            )
          })}
        </div>
      </div>

      <div className="post-sidebar-card">
        <h2>Newsletter</h2>
        <p>
          Get notified when a new paper was published!
        </p>
        <p>
          <a
            href="https://birkenbihl.substack.com"
            target="_blank"
            rel="noopener noreferrer"
            className="button highlighted"
          >
            Subscribe to the Newsletter
          </a>
        </p>
      </div>
    </aside>
  )
}
